<template>
    <div>
        <v-select v-model="multiCampus" :options="hasCampusOptions" v-if="canEditMessages"></v-select>
        <template v-if="multiCampus">
            <div v-for="(child, index) in message.children" :key="child.id" class="mb-1">
                <b-button-group v-if="findCampus(child.campus_id)">
                    <b-button class="mb-2 mt-0" variant="danger" size="sm" v-on:click="destroy(index)">
                        <icon icon="bin"></icon>
                    </b-button>
                    <b-button class="mb-2 mt-0" variant="gray" :href="`/messages/${message.id}/campuses/${child.campus_id}/messages/${child.id}/edit`" size="sm">
                        {{ findCampus(child.campus_id).name }}   <icon icon="pencil" class="ml-3"></icon>
                    </b-button>
                </b-button-group>
            </div>

            <div v-if="hasAvailableCampuses">
                <form method="POST" :action="this.url">
                    <v-select :options="this.campusOptions" v-model="campusId" class="mb-0"></v-select>
                    <button class="mb-2 mt-0 btn btn-block btn-secondary btn-sm" type="submit">Add Campus</button>
                </form>
            </div>
        </template>
        <template v-else>
            <template v-if="message.allows_children && canEditMessages">
                <p>Are you sure?</p>
                <button class="mb-2 mt-0 btn btn-block btn-danger btn-sm" @click="disallow">Click to delete all campus child messages</button>
            </template>

        </template>
    </div>
</template>

<script>
    import Icon from "../Icon";
    import axios from 'axios'

    export default {
        components: {Icon},
        props: ['availableCampuses', 'message', 'campuses', 'canEditMessages'],
        data() {
            return {
                campusId: null,
                multiCampus: true,
                hasCampusOptions: [
                    {
                        text: 'This message will be at multiple campuses.',
                        value: true
                    },
                    {
                        text: 'This message will be at a single campus.',
                        value: false
                    }
                ]
            }
        },
        created() {
            this.multiCampus = !!this.message.allows_children
        },
        watch: {
            multiCampus(current, old) {
                if (!old && current) {
                    this.allow();
                }
            }
        },
        computed: {
            campusOptions() {
                let options = this.availableCampuses.map((campus) => {
                    return {
                        text: campus.name,
                        value: campus.id
                    }
                })
                options.unshift({
                    text: 'Choose...',
                    value: null
                })
                return options
            },
            url() {
                return `/messages/${this.message.id}/campuses/${this.campusId}/messages`
            },
            hasAvailableCampuses() {
                return this.availableCampuses.length
            }
        },
        methods: {
            handleSubmit() {
                window.location.href = this.url
            },
            findCampus(id)
            {
                return this.campuses.find(function(campus) {
                    return campus.id === id
                })
            },
            destroy(index)
            {
                let confirmed = confirm('Are you sure? Deleting this campus will cause it to default to the parent message content.')
                if (!confirmed) return

                let toDelete = this.message.children[index]

                let promise = axios.delete('/messages/' + toDelete.id)
                return promise.then(() => {
                    location.reload()
                }).catch(error => {
                    alert('The message could not be deleted.')
                })
            },
            disallow()
            {
                let promise = axios.put('/messages/' + this.message.id + '/campuses/disallow')
                return promise.then(() => {
                    location.reload()
                }).catch(error => {
                    alert('An error has occurred.')
                })
            },
            allow()
            {
                let promise = axios.put('/messages/' + this.message.id + '/campuses/allow')
                return promise.then(() => {
                    //location.reload()
                }).catch(error => {
                    alert('An error has occurred.')
                })
            }
        }
    }
</script>


